<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="开始日期" prop="date">
        <DatePicker
          class="c-form__input"
          :value="cForm.model.date"
          type="date"
          placeholder="请选择开始日期"
          @on-change="
            value => {
              $set(cForm.model, 'date', value);
            }
          "
        />
      </Form-item>
      <Form-item label="上课时间" prop="time">
        <TimePicker
          class="c-form__input"
          format="HH:mm"
          type="timerange"
          placement="bottom-start"
          placeholder="请选择上课时间"
          :value="cForm.model.time"
          @on-change="
            value => {
              $set(cForm.model, 'time', value);
            }
          "
        >
        </TimePicker>
      </Form-item>
      <Form-item label="任课老师" prop="teacherId">
        <c-teacher-select
          class="c-form__input"
          :value="cForm.model.teacherId"
          @change="
            value => {
              $set(cForm.model, 'teacherId', value);
            }
          "
        >
        </c-teacher-select>
      </Form-item>
      <Form-item label="重复" prop="period">
        <Select class="c-form__input" v-model="cForm.model.period">
          <Option
            v-for="item in dicts.CoursePeriod"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
      <Form-item v-if="cForm.model.period === 2" label="周几" prop="weekId">
        <Select class="c-form__input" v-model="cForm.model.weekId">
          <Option
            v-for="item in dicts.Week"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
      <Form-item
        v-if="cForm.model.period !== 0"
        label="重复次数"
        prop="repeatTimes"
      >
        <InputNumber v-model="cForm.model.repeatTimes" :min="1"></InputNumber>
      </Form-item>
      <Form-item label="是否补课" prop="makeUp">
        <Select class="c-form__input" v-model="cForm.model.makeUp">
          <Option
            v-for="item in dicts.Is"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "courses";

@Component({
  mixins: [FormMixin]
})
export default class ListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          date: [
            {
              required: true,
              message: "开始日期不能为空"
            }
          ],
          time: [
            {
              required: true,
              message: "上课时间不能为空"
            }
          ],
          teacherId: [
            {
              required: true,
              message: "任课老师不能为空"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {
      period: 0,
      teacherId: "",
      repeatTimes: 1,
      makeUp: 0
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: {
              ...model,
              classId: this.$route.params.classId
            }
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
